/** Single source of truth for display prices. Update here when Stripe price changes. */
export const PRICE_EUR = '€9.99'
export const PRICE_LABEL = `Upgrade — ${PRICE_EUR}`
export const PRICE_LABEL_FULL = `Upgrade now — ${PRICE_EUR}`

/** One-off decision pass: Premium limits for a single decision. Matches STRIPE_PASS_PRICE_ID. */
export const PASS_PRICE_EUR = '€0.99'
